import React, { useState } from "react";
import { ClinicalFormsConstants } from "../ClinicalForms/ClinicalFormsConstants";
import { formatDateTime } from "../../helper/dateFormatter";
import { useNavigate } from "react-router-dom";
import { updateMemberFormStatus, useAssessmentParams } from "./apiUtils.assessment";
import { MemberFormInfo } from "clinical-forms-experience-client";
import EndAssessmentModal from "./EndAssessmentModal";

interface FooterAssessmentsProps {
  lastSaveTime?: Date | null;
  memberForm?: MemberFormInfo | null;
  allAnswersGiven: boolean;
  handleFormSubmit: () => void;
  submitPgis(): Promise<void>
}

const AssessmentsFooter: React.FC<FooterAssessmentsProps> = ({
  lastSaveTime,
  memberForm,
  allAnswersGiven,
  handleFormSubmit,
  submitPgis
}) => {
  const [isEndAssessmentVisible, setIsEndAssessmentVisible] = useState(false);

  const { patientId, memberFormId, editPgis } = useAssessmentParams();
  const navigate = useNavigate();

  const formSubmitted = memberForm?.status === ClinicalFormsConstants.submittedStatus;

  const navigateToGrid = () => {
    navigate(`/patients/${patientId}/assessments`);
  };

  const handleEndAssessment = async (reason: string) => {
    if (!reason) {
      return;
    }
    if (memberForm?.status !== ClinicalFormsConstants.submittedStatus) {
      await updateMemberFormStatus(
        ClinicalFormsConstants.discardedStatus,
        memberFormId!,
        reason
      );
      setIsEndAssessmentVisible(false);
    }
    navigateToGrid();
  };

  return (
    <div className="assessment__footer d-flex gap-2 fs-12">
      {(lastSaveTime && !formSubmitted) && (<span>Draft auto saved at {formatDateTime(lastSaveTime)}</span>)}

      {/* Display Submit and Close button only if form is not submitted and editPgis is false */}
      {(!formSubmitted || !editPgis) && (
        <>
          <button
            className="btn btn-primary btn-sm rounded-pill px-5"
            disabled={!allAnswersGiven || formSubmitted}
            onClick={handleFormSubmit}
          >
            Submit
          </button>
          <button
            className="btn btn-outline-primary btn-sm rounded-pill px-5"
            onClick={navigateToGrid}
          >
            Close
          </button>
        </>
      )}

      {/* Display Save PGIs button only if the form is submitted and editPgis is true */}
      {formSubmitted && editPgis && (
        <button
          className="btn btn-outline-primary btn-sm rounded-pill px-5"
          onClick={submitPgis}
        >
          Save PGIs
        </button>
      )}
      <button
        className="btn btn-outline-primary btn-sm rounded-pill px-5"
        onClick={() => setIsEndAssessmentVisible(true)}
        disabled={(formSubmitted && !editPgis)}
      >
        End Assessment
      </button>
      <EndAssessmentModal
        show={isEndAssessmentVisible}
        onHide={() => setIsEndAssessmentVisible(false)}
        onConfirm={handleEndAssessment}
      />
    </div>
  );
};

export default AssessmentsFooter;
